import { of } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { Injector } from '@angular/core';
import { ProfilePathItemDTO } from '../../../../dto/educational-path/profile-path-item.dto';

export function profile_paths_competence(componentDataSourceService: ComponentDataSourceService & { injector: Injector }) {
    return {
        name: 'Kompetencevurdering',
        description: 'Krævede uddannelser og vedligeholdelse fra kompetencevurdering',
        execute: () => {
            return of<ProfilePathItemDTO[]>([]); // Return empty array as competence check is not implemented yet
        },
        settings: {
            columns: [
                { 
                    key: 'name', 
                    header: 'Modul', 
                    type: 'text-with-subtitle',
                    subtitle: 'subtypes'
                },
                { key: 'participation_status', header: 'Status', type: 'text' },
                { key: 'type', header: 'Type', type: 'text' },
                {
                    key: 'module_name',
                    header: '',
                    type: 'button',
                    buttonText: 'Find tilmelding',
                    buttonColor: 'primary',
                    alignment: 'right',
                    variant: 'raised',

                    action: (row: any) => {
                        const searchParams = new URLSearchParams({
                            search: row.module_name,
                            type: 'module'
                        });
                        window.location.href = `/events?${searchParams.toString()}`;
                    }
                }
            ],
            pageable: false,
            sortable: false,
            rowHover: true,
            defaultSortColumn: 'name',
            defaultSortDirection: 'asc'
        }
    };
} 